import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { getCustomerGiftCodesQuery } from "rsl-api-106/lib/queries";
import {
  GiftCode,
  Query,
  QueryGetCustomerGiftCodesArgs,
} from "rsl-api-106/lib/types";

import { useApolloClient } from "@apollo/client";
import { useAuth, useSession } from "@hooks";
import { getCurrencySymbol } from "@utils/currencies";
import dateFormat from "@utils/dateformat";

type RewardAreaProps = {
  //
};

const languagesVarsCodes = [
  "LANG_neobooking_area_reward_no_rewards", //lorsque vous pourrez bénéficier d'une récompense, celle-ci apparaîtra ici.
  "LANG_neobooking_area_reward_is_available", //Votre e-chèque est disponible
  "LANG_neobooking_area_reward_until", //jusqu'au
  "LANG_neobooking_area_reward_echeque_num", //E-CHEQUE N°:
];

const RewardArea: React.FC<RewardAreaProps> = () => {
  /* Hooks */
  const client = useApolloClient();
  const { sessionId, getLanguageVarValue } = useSession();
  const { user } = useAuth();

  /* State */
  const [giftCodes, setGiftCodes] = useState<GiftCode[]>();

  useEffect(() => {
    if (sessionId) {
      client
        .query<Query, QueryGetCustomerGiftCodesArgs>({
          query: getCustomerGiftCodesQuery(),
          variables: {
            session: { name: sessionId },
          },
          fetchPolicy: "no-cache",
        })
        .then((response) => {
          if (response.data.getCustomerGiftCodes?.giftCodes) {
            setGiftCodes(
              response.data.getCustomerGiftCodes?.giftCodes as GiftCode[]
            );
          }
        });
    }
  }, [sessionId]);

  return (
    <>
      {
        /* on prend les giftcode valid et non utilisé */
        giftCodes?.filter((x) => x.valid && !x.used)?.length ?? 0 > 0 ? (
          <>
            {giftCodes
              ?.filter((x) => x.valid && !x.used)
              .map((giftCode, i) => {
                return (
                  <ECheque
                    key={`echeque_${giftCode.code}_${i}`}
                    giftCode={giftCode}
                  />
                );
              })}
          </>
        ) : (
          <>
            <NoRewardArea name={user?.firstName!!} />
          </>
        )
      }
    </>
  );
};

type EChequeProps = {
  giftCode: GiftCode;
};

const ECheque: React.FC<EChequeProps> = ({ giftCode }) => {
  /* Hooks */
  const { getLanguageVarValue } = useSession();

  return (
    <div className="tw-max-w-md tw-text-center tw-shadow tw-py-4 tw-px-8 tw-mx-auto">
      <div className="tw-font-bold tw-text-3xl">
        {giftCode.amount?.amount}
        {getCurrencySymbol(giftCode.amount?.currencyCode!!)}
      </div>
      <div className="tw-font-bold tw-text-xl tw-mb-4">
        {getLanguageVarValue("LANG_neobooking_area_reward_echeque_num")}{" "}
        {giftCode.code}
      </div>
      <div>
        {getLanguageVarValue("LANG_neobooking_area_reward_is_available")}
        <br />
        {getLanguageVarValue("LANG_neobooking_area_reward_until")}{" "}
        {dateFormat(new Date(giftCode.validityDate), "dd/mm/yyyy")}
      </div>
    </div>
  );
};

type NoRewardAreaProps = {
  name: string;
};
const NoRewardArea: React.FC<NoRewardAreaProps> = ({ name }) => {
  /* Hooks */
  const { getLanguageVarValue } = useSession();

  return (
    <div className="tw-max-w-md tw-text-center tw-shadow tw-py-4 tw-px-8 tw-mx-auto">
      <div className="tw-font-bold tw-text-3xl tw-mb-4">{name},</div>
      <div>{getLanguageVarValue("LANG_neobooking_area_reward_no_rewards")}</div>
    </div>
  );
};

RewardArea.propTypes = {
  //
};

export default RewardArea;
